export default __webpack_public_path__ + "c433bd72d9cbce20848649bc372877fa.svg";